import _ from 'lodash';
window._ = _;

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + window.Laravel.apiToken,
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

window.axios.interceptors.request.use((config) => {
    if (config.url.indexOf('api.vimeo.com') > -1) {
        delete config.headers.common;
    }

    return config;
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
